import { Alpine } from '../core/alpine-core.js';
import { avatarUploader } from './avatarUploader.js';
import { uiSwitch } from './uiSwitch.js';

/**
 * Pinecone `x-handler="[setTitle('…')]"` evaluates in the global scope, not on `adminApp`.
 * Register handlers on `globalThis` so route templates always resolve them.
 */
export function routeSetTitle(title) {
    return () => {
        Alpine.store('ui').setHideChrome(false);
        document.title = title;
        queueMicrotask(() => window.scrollTo({ top: 0, behavior: 'instant' }));
    };
}

/** Public auth routes — hide header/footer chrome (same as login). */
export function routeAuthPageInit(title = 'DartsOS') {
    return () => {
        Alpine.store('ui').setHideChrome(true);
        document.title = title;
        queueMicrotask(() => window.scrollTo({ top: 0, behavior: 'instant' }));
    };
}

export function routeLoginInit() {
    return routeAuthPageInit('Sign in — DartsOS');
}

globalThis.setTitle = routeSetTitle;
globalThis.authPageInit = routeAuthPageInit;
globalThis.loginInit = routeLoginInit;

Alpine.data('adminApp', () => ({
    routeRoot() {
        const s = Alpine.store('session');
        if (s?.token && s?.me) this.$router.navigate('/admin/dashboard');
        else this.$router.navigate('/login');
    },
    requireAuth() {
        const s = Alpine.store('session');
        if (!s?.token || !s?.me) {
            Alpine.store('ui').setHideChrome(true);
            this.$router.navigate('/login');
            return;
        }
        Alpine.store('ui').setHideChrome(false);
    },
    setTitle: routeSetTitle,
    authPageInit: routeAuthPageInit,
    loginInit: routeLoginInit,
}));

Alpine.data('avatarUploader', avatarUploader);
Alpine.data('uiSwitch', uiSwitch);

// Register other admin modules
import './no-auth.js';
import './userProfile.js';
import './admin-forgot-password.js';
import './admin-login.js';
import './admin-register.js';
import './admin-reset-password.js';
import './admin-reset-otp.js';
import './admin-setup.js';

import './dashboard/dashboard.js';
import '../public/dashboard-widgets.js';
import './league-home.js';
import './league-detail.js';
import './dashboard-layout.js';
import './scorer-layout-builder.js';
import './league-table.js';

import './fixtures/list.js';
import './fixtures/view.js';
import './fixtures/score.js';
import './tv-pair.js';
import './fixtures/viewer.js';
import './fixtures/board.js';
import './fixtures/summary.js';
import './fixtures/edit.js';

import './players/list.js';
import './players/edit.js';
import './players/view.js';

import './teams/list.js';
import './teams/view.js';
import './teams/edit.js';

import './venues/list.js';
import './venues/view.js';
import './venues/edit.js';

import './league-rules/list.js';
import './league-rules/edit.js';
import './league-builder.js';
import './tournaments/list.js';
import './tournaments/detail.js';
import './tournaments/wizard.js';
import './tournaments/bracket-view.js';
import './tournaments/tournament-match-console.js';
import './tournaments/tournament-match-scorer.js';
import './tournaments/tournament-match-board.js';
import './backup-sync.js';
import './account-settings.js';
import './welcome-wizard.js';

import './scoresheet.js';
import './quick-match.js';
import './challenges.js';
import './challenges/board.js';
import './challenges/scorer.js';

import './training/list.js';
import './training/launch.js';
import './training/scorer.js';

